import { logRelatedTypes } from "@/common/constants/logRelatedTypes";

export const ADMIN_ACTOR_IDENTIFIERS = [
  logRelatedTypes.AdminUser.toLowerCase(),
  "admin",
  "t.card",
  "tcard",
  "t_card",
];

export const SYSTEM_ACTOR_IDENTIFIERS = ["system"];
